// ---- Helpers ----
const StatusPill = ({ status }) => {
	const isActive = status === 'active';
	const cls = isActive ? 'bg-lightGreen text-textGreen' : 'bg-lightRed text-textRed';
	const label = isActive ? 'Active' : status === 'inactive' ? 'Inactive' : status;
	return (
		<span className={`px-3 py-2 inline-flex text-xs leading-5 font-semibold rounded-full ${cls}`}>
			{label}
		</span>
	);
};

const Actions = ({ onEditClick, onDeleteClick, disabled }) => (
	<div className="flex items-center space-x-2">
		{/* Edit icon */}
		<svg
			onClick={!disabled ? onEditClick : undefined}
			className={`${disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'}`}
			width="22"
			height="22"
			viewBox="0 0 22 22"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g opacity="0.6">
				<path
					d="M17.3492 2.87562C17.0915 2.61772 16.7854 2.41316 16.4485 2.27362C16.1117 2.13407 15.7506 2.06229 15.386 2.06238C15.0214 2.06246 14.6603 2.13441 14.3235 2.27411C13.9867 2.41381 13.6808 2.61852 13.4231 2.87654L4.70839 11.6032C4.18913 12.1237 3.89739 12.8288 3.89714 13.564V16.5C3.89714 16.8795 4.20514 17.1875 4.58464 17.1875H7.53905C8.27514 17.1875 8.98097 16.8942 9.50072 16.3745L18.2091 7.66062C18.7285 7.13993 19.0202 6.43446 19.0202 5.69896C19.0202 4.96345 18.7285 4.25798 18.2091 3.73729L17.3492 2.87562ZM3.66797 18.5625C3.48563 18.5625 3.31076 18.635 3.18183 18.7639C3.0529 18.8928 2.98047 19.0677 2.98047 19.25C2.98047 19.4324 3.0529 19.6072 3.18183 19.7362C3.31076 19.8651 3.48563 19.9375 3.66797 19.9375H18.3346C18.517 19.9375 18.6918 19.8651 18.8208 19.7362C18.9497 19.6072 19.0221 19.4324 19.0221 19.25C19.0221 19.0677 18.9497 18.8928 18.8208 18.7639C18.6918 18.635 18.517 18.5625 18.3346 18.5625H3.66797Z"
					fill="#180A63"
				/>
			</g>
		</svg>

		{/* Delete icon */}
		<svg
			onClick={!disabled ? onDeleteClick : undefined}
			className={`${disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'}`}
			width="22"
			height="22"
			viewBox="0 0 22 22"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g opacity="0.6">
				<path
					d="M17.8305 6.875H4.17214C4.10873 6.8748 4.04598 6.88775 3.98784 6.91304C3.9297 6.93833 3.87744 6.97541 3.83436 7.02194C3.79128 7.06846 3.75833 7.12341 3.73758 7.18332C3.71682 7.24323 3.70873 7.3068 3.7138 7.37L4.88714 20.3317C4.92844 20.7888 5.13968 21.2137 5.47912 21.5226C5.81857 21.8315 6.26152 22.0019 6.72047 22H15.2821C15.7411 22.0019 16.184 21.8315 16.5235 21.5226C16.8629 21.2137 17.0742 20.7888 17.1155 20.3317L18.3346 7.33333C18.3397 7.27013 18.3316 7.20657 18.3109 7.14666C18.2901 7.08675 18.2572 7.03179 18.2141 6.98527C18.171 6.93875 18.1187 6.90167 18.0606 6.87637C18.0025 6.85108 17.9397 6.83813 17.8763 6.83833L17.8305 6.875ZM9.39714 18.7917C9.39714 18.974 9.3247 19.1489 9.19577 19.2778C9.06684 19.4067 8.89197 19.4792 8.70964 19.4792C8.5273 19.4792 8.35243 19.4067 8.2235 19.2778C8.09457 19.1489 8.02214 18.974 8.02214 18.7917V10.5417C8.02214 10.3593 8.09457 10.1845 8.2235 10.0555C8.35243 9.9266 8.5273 9.85417 8.70964 9.85417C8.89197 9.85417 9.06684 9.9266 9.19577 10.0555C9.3247 10.1845 9.39714 10.3593 9.39714 10.5417V18.7917ZM13.9805 18.7917C13.9805 18.974 13.908 19.1489 13.7791 19.2778C13.6502 19.4067 13.4753 19.4792 13.293 19.4792C13.1106 19.4792 12.9358 19.4067 12.8068 19.2778C12.6779 19.1489 12.6055 18.974 12.6055 18.7917V10.5417C12.6055 10.3593 12.6779 10.1845 12.8068 10.0555C12.9358 9.9266 13.1106 9.85417 13.293 9.85417C13.4753 9.85417 13.6502 9.9266 13.7791 10.0555C13.908 10.1845 13.9805 10.3593 13.9805 10.5417V18.7917ZM20.168 3.66667H15.8138C15.753 3.66667 15.6947 3.64252 15.6518 3.59955C15.6088 3.55657 15.5846 3.49828 15.5846 3.4375V2.29167C15.5846 1.68388 15.3432 1.10098 14.9134 0.671214C14.4837 0.241443 13.9008 0 13.293 0L8.70964 0C8.10185 0 7.51895 0.241443 7.08918 0.671214C6.65941 1.10098 6.41797 1.68388 6.41797 2.29167V3.4375C6.41797 3.49828 6.39383 3.55657 6.35085 3.59955C6.30787 3.64252 6.24958 3.66667 6.1888 3.66667H1.83464C1.59152 3.66667 1.35836 3.76324 1.18645 3.93515C1.01455 4.10706 0.917969 4.34022 0.917969 4.58333C0.917969 4.82645 1.01455 5.05961 1.18645 5.23151C1.35836 5.40342 1.59152 5.5 1.83464 5.5H20.168C20.4111 5.5 20.6442 5.40342 20.8162 5.23151C20.9881 5.05961 21.0846 4.82645 21.0846 4.58333C21.0846 4.34022 20.9881 4.10706 20.8162 3.93515C20.6442 3.76324 20.4111 3.66667 20.168 3.66667ZM8.2513 3.4375V2.29167C8.2513 2.17011 8.29959 2.05353 8.38555 1.96758C8.4715 1.88162 8.58808 1.83333 8.70964 1.83333H13.293C13.4145 1.83333 13.5311 1.88162 13.6171 1.96758C13.703 2.05353 13.7513 2.17011 13.7513 2.29167V3.4375C13.7513 3.49828 13.7272 3.55657 13.6842 3.59955C13.6412 3.64252 13.5829 3.66667 13.5221 3.66667H8.48047C8.41969 3.66667 8.3614 3.64252 8.31842 3.59955C8.27545 3.55657 8.2513 3.49828 8.2513 3.4375Z"
					fill="#E90B0F"
				/>
			</g>
		</svg>
	</div>
);

const AccessManagementTable = ({ accessUsers, onEditSubAdmin, onDeleteSubAdmin }) => {
	const styles = {
		tableDiv: 'bg-white rounded-lg overflow-auto mb-10',
		topTableHead: 'px-3.5 py-3.5 text-base leading-100 font-medium text-gray text-left',
		tableData: 'px-3.5 py-3.5 text-base font-medium text-dark-blue leading-100 text-left'
	};

	return (
		<div className={styles.tableDiv}>
			<div className="w-full">
				<table className="min-w-[680px] xl:min-w-full">
					<thead className="bg-[#F2F3F7]">
						<tr>
							<th scope="col" className={styles.topTableHead}>
								NAME
							</th>
							<th scope="col" className={styles.topTableHead}>
								EMAIL
							</th>
							<th scope="col" className={styles.topTableHead}>
								ROLE
							</th>
							<th scope="col" className={styles.topTableHead}>
								STATUS
							</th>
							<th scope="col" className={styles.topTableHead}>
								ACTIONS
							</th>
						</tr>
					</thead>

					<tbody className="bg-white">
						{accessUsers.map((u) => {
							const isSuperAdmin = u.role === 'Super Admin';
							return (
								<tr key={u.email}>
									<td className={styles.tableData}>{u.name}</td>
									<td className={styles.tableData}>{u.email}</td>
									<td className={styles.tableData}>{u.role}</td>
									<td className="px-4 py-3.5 text-base">
										<StatusPill status={u.status} />
									</td>
									<td className="px-4 py-3.5 text-base">
										<Actions
											disabled={isSuperAdmin}
											onEditClick={() => onEditSubAdmin(u)}
											onDeleteClick={() => onDeleteSubAdmin(u)}
										/>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default AccessManagementTable;
